<template>
  <div class="content">
    <!-- 页面标题 -->
    <div v-wechat-title="'提灯与地下城'"></div>
    <!-- 移动端 -->
    <div id="new-main-mobile" ref="mobile" :style="mainMobileStyle">
      <!-- 头部 -->
      <header class="new_header" :class="'new-header-login-' + headerLogin">
        <div class="acco">{{ user_info.user_id ? `${user_info.role_name} ${user_info.server_name ?
          `[${user_info.server_name}]` : ''}` : '请先登录' }}</div>
        <a class="new-download-btn" title="下载按钮" @click="goOfficeWeb"></a>
        <a v-if="!user_info.user_id" class="new-logon-btn" @click="logon()" title="登录&切换按钮"></a>
        <a v-if="user_info.user_id && userInfo.os !== 'bilibili'" class="new-switch-btn" @click="switchBtn()"></a>
        <a v-if="user_info.user_id && userInfo.os == 'bilibili'" class="new-logout-btn" @click="qhBtn()"></a>
      </header>

      <div class="new_content_01">
        <div class="text-container">
          <img class="animated zoomInDown"
            src="https://download4.qcplay.com/qcgame-api/BnsgFZAd5GAEhZ8uO7kr9dCYSj3BWaw7xdVGaAzg.png" />
        </div>
        <div class="welfare-text-one zoomInDown"></div>
        <div class="download-game" @click="downloadGame"></div>
        <div class="welfare-text-two zoomInDown"></div>
        <div class="egg-container" @click="clickEgg">
          <div class="fire"></div>
          <div class="number"></div>
          <div class="hint-pulse"></div>
        </div>
      </div>

      <div class="new_content_02" :style="taskHeight">
        <div class="task-bg" :style="taskBgStyle">
          <!-- 展示上一期卡牌 -->
          <div class="history-section" v-if="showHistory && card_record.length > 0" :style="historyTop">
            <div class="history-cards">
              <div v-for="(card, index) in card_record" :key="'history-' + card + index" class="history-card">
                <div class="card" :class="['card-' + (currentRewardId < 4 ? 'a_' : '') + card]"></div>
              </div>
            </div>
            <div class="prev-text">
              <p>上局奖励:{{ prevText }}</p>
            </div>
          </div>
          <!-- 魔法币数量 -->
          <div class="coin-container" @click="coinClick" :style="coinTop">
            <span class="span-one">魔法币:</span><span class="span-two">{{ help_number }}</span>
          </div>
          <!-- 规则奖励按钮 -->
          <div class="rule-btn" @click="popSwitch('ruleRewardShow', true)" :style="ruleHeight"></div>
          <!-- 翻翻乐图鉴按钮 -->
          <div class="tj-btn" @click="popSwitch('tjShow', true)" :style="tjHeight"></div>
          <!-- 新增卡片容器 -->
          <div class="card-container" :style="cardContainerHeight">
            <div v-for="(card, index) in cards" :key="index" class="card" :class="[
              'card-' + (currentRewardId < 4 ? 'a_' : '') + card.image,
              { 'flip': card.isFlipped }
            ]">
              <div class="card-back" :class="'card-' + card.image"></div>
              <div class="card-front"></div>
            </div>
          </div>

          <div class="turn-btn" v-if="!record_id" @click="DebounceFlipCards" :style="turnTop">
            <p class="task-time">可参与次数: {{ task_time }}</p>
          </div>

          <div class="remake-container" :style="remakeTop" v-else>
            <div class="left-btn">
              <div class="remake-btn" @click="handleSmartRemake(true)"></div>
              <p>消耗1魔法币重开</p>
            </div>
            <div class="right-btn">
              <div class="get-reward" @click="popSwitch('happyShow', true)"></div>
            </div>
          </div>

          <div class="activity-tip" :style="tipTop">活动期间可消耗翻牌次数{{ consume }}/24，第24次必得<span>神话魔法罐*10</span></div>


          <div class="btn-container" v-if="consume < 24">
            <div v-for="(item, index) in task_list" :class="[
              'item',
              `item-${item.status}`
            ]" :key="index" @click="handleClick(item.id)">
            </div>
          </div>

          <div class="bottom-container" v-if="consume < 24">
            <div class="refresh-btn" @click="DebounceRefresh"></div>
            <div class="all-get-btn" @click="DebounceAllGetReward"></div>
          </div>
        </div>
      </div>

      <div class="new_content_03">
        <div class="go-container">

          <div class="go_content">

            <div class="go_content_item live">
              <div class="go_content_item_btn" @click="jump('live')">
              </div>
            </div>

            <div class="go_content_item sign">
              <div class="go_content_item_btn" @click="jump('sign')">
              </div>
            </div>

            <div class="go_content_item turntable">
              <div class="part_btn" @click="jump('turntable')">
              </div>
            </div>
          </div>

        </div>
      </div>


      <div class="rule-reward-wrap popup_wrap" v-show="ruleRewardShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="rule-reward-box popup_wrap-box" v-show="ruleRewardShow">
            <!-- 内容区域 -->
            <div class="content-area">
              <div class="content-item rule-content" :class="{ active: activeTab === 'rule' }"></div>
              <div class="content-item reward-content" :class="{ active: activeTab === 'reward' }">
                <div class="list">
                  <div v-if="reward_record.length == 0">暂无数据</div>
                  <ul v-else>
                    <li v-for="(item, index) in reward_record" :key="index"><span>{{ item.created_at }}</span><span>{{
                      item.remark
                        }}</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Tab按钮 -->
            <div class="tab-buttons">
              <div class="tab-btn rule-tab" :class="{ active: activeTab === 'rule' }" @click="switchTab('rule')"></div>
              <div class="tab-btn reward-tab" :class="{ active: activeTab === 'reward' }" @click="switchTab('reward')">
              </div>
            </div>

            <div class="close-btn" @click="popSwitch('ruleRewardShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('ruleRewardShow', false)"></div>
      </div>

      <!-- 重开奖励弹窗 这个是领取到最高奖励的 -->
      <div class="remake-wrap popup_wrap" v-show="remakeShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="remake-box popup_wrap-box" v-show="remakeShow">
            <div class="happy-container">
              <div class="left-btn">
                <div class="remake-btn" @click="handleSmartRemake(false)"></div>
                <div class="flex-text">
                  <span>消耗1魔法币重开,剩余:</span>
                  <span class="help-text">{{ help_number }}</span>
                </div>
              </div>
              <div class="right-btn">
                <div class="get-reward" @click="getFinalReward"></div>
              </div>
            </div>
            <div class="close-btn" @click="closeRemakeShow"></div>
          </div>
        </transition>
        <div class="close-bg" @click="closeRemakeShow"></div>
      </div>

      <!-- 恭喜获奖弹窗 -->
      <div class="happy-wrap popup_wrap" v-show="happyShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="happy-box popup_wrap-box" v-show="happyShow">
            <div class="text-container">
              <p class="top-text">{{ prevText }}</p>
              <div class="reward-img" :style="{ backgroundImage: 'url(' + rewardImageMap[currentRewardId] + ')' }">
              </div>
              <p class="bottom-text">{{ rewardNameMap[currentRewardId] }}</p>
            </div>
            <div class="happy-container">
              <div class="left-btn">
                <div class="remake-btn" @click="handleSmartRemake(true)"></div>
                <div class="flex-text">
                  <span>消耗1魔法币重开,剩余:</span>
                  <span class="help-text">{{ help_number }}</span>
                </div>
              </div>
              <div class="right-btn">
                <div class="get-reward" @click="getFinalReward"></div>
              </div>
            </div>
            <div class="close-btn" @click="closeHappyShow"></div>
          </div>
        </transition>
        <div class="close-bg" @click="closeHappyShow"></div>
      </div>

      <!-- 翻翻乐图鉴弹窗 -->
      <div class="tujian-wrap popup_wrap" v-show="tjShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="tujian-box popup_wrap-box" v-show="tjShow">
            <!-- <div class="tujian-content"></div> -->
            <div class="scroll-container"> <!-- 新增滚动容器 -->
              <div class="tujian-content"></div>
            </div>
            <div class="close-btn" @click="popSwitch('tjShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('tjShow', false)"></div>
      </div>

      <!-- 今日已经助力过该玩家弹窗 -->
      <div class="helped-wrap popup_wrap" v-show="helpedShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="helped-box popup_wrap-box" v-show="helpedShow">
            <div class="download-game" @click="downloadGame"></div>
            <div class="go-h5" @click="popSwitch('helpedShow', false)"></div>
            <div class="close-btn" @click="popSwitch('helpedShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('helpedShow', false)"></div>
      </div>

      <!-- 不能助力自己的弹窗 -->
      <div class="help-self-wrap popup_wrap" v-show="helpSelfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="help-self-box popup_wrap-box" v-show="helpSelfShow">
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接"
              :data-clipboard-text="shareText">
            </div>
            <div class="close-btn" @click="popSwitch('helpSelfShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('helpSelfShow', false)"></div>
      </div>
      <!-- 欧气爆棚 我来助你弹窗 -->
      <div class="help-wrap popup_wrap" v-show="helpShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="help-box popup_wrap-box" v-show="helpShow">
            <div class="help-you" @click="checkLogin"></div>
            <div class="close-btn" @click="popSwitch('helpShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('helpShow', false)"></div>
      </div>

      <!-- 助力成功弹窗 -->
      <div class="success-help-wrap popup_wrap" v-show="successHelpShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="success-help-box popup_wrap-box" v-show="successHelpShow">
            <div class="download-game" @click="downloadGame"></div>
            <div class="go-h5" @click="popSwitch('successHelpShow', false)"></div>
            <div class="close-btn" @click="popSwitch('successHelpShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('successHelpShow', false)"></div>
      </div>

      <!-- 彩蛋弹窗 -->
      <div class="egg-wrap popup_wrap" v-show="eggShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="egg-box popup_wrap-box" v-show="eggShow">
            <div class="get-btn" @click="getEgg"></div>
            <div class="close-btn" @click="popSwitch('eggShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('eggShow', false)"></div>
      </div>

      <!-- 分享相关DOM -->
      <div class="share-box-hlw" ref="imageDom">
        <img src="https://download4.qcplay.com/tideng/new-version/dialog/new_pop.png" />
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>

      <!-- 分享弹窗 -->
      <div :class="'help-share-wrap popup_wrap help-share-wrap-' + shareShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }" v-show="shareShow">
          <div class="help-share-box popup_wrap-box">
            <div class="bottom-img">
              <div class="qrcode-box">
                <div id="qrcode2" class="qrcode"></div>
              </div>
            </div>
            <img :src="shareImg" alt="分享图片" />
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接"
              :data-clipboard-text="shareText">
            </div>
            <div class="close-btn" @click="popSwitch('shareShow', false)"></div>
            <div class="share-text"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('shareShow', false)"></div>
      </div>

      <!-- 微信下载引导 -->
      <div class="guide-container popup_wrap" v-show="guideShow" @click="popSwitch('guideShow', false)">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }" v-show="guideShow">
          <div class="guide-container-box popup_wrap-box">
          </div>
        </transition>
      </div>
      <!-- 注销弹窗 -->
      <div class="logout-wrap popup_wrap" v-show="logoutShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="logout-box popup_wrap-box" v-show="logoutShow">
            <p>是否退出当前账号</p>
            <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
            <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
          </div>
        </transition>
      </div>

      <!-- 登录弹窗 -->
      <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='onBind()' :gameName="gameName"
        :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看'>
      </Login>

      <!-- 绑定弹窗 -->
      <Os v-if='isShowOs' v-on:selectCallback='onBind()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>
    </div>
    <Footer :gameName="gameName" class="max-width" />
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>

<script>
import _ from "lodash";
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { onInitAPI, doTaskAPI, getRewardAPI, onHelpAPI, onTurnAPI, onGetRewardAPI, noSecLogin } from '../api'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getTimeStamp, analysisParams, buriedLogger, getRandomString } from '@/utils/utils';
import Os from '../os';
import Login from '../login'
import { LogoutAPI } from "../new-login";
import Footer from '@/components/Footer';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'new-version',
  components: {
    Login,
    Os,
    Footer
  },
  data() {
    return {
      guideShow: false,
      showHistory: false, // 新增控制历史记录显示的状态
      shareText: '',
      shareShow: false,
      eggShow: false, // 彩蛋弹窗
      lastAPICallTime: 0,    // 新增：最后请求时间戳
      clickCoolDown: 3500,
      open_like: '', // 企业微信链接
      is_get_egg: false,
      isGettingEgg: false,
      shareImg: null,
      reward_id: '', // 当前的奖励id
      preventShow: false,
      delayShow: false,
      // 新增点击时间记录
      lastClickTime: 0,
      isGettingReward: false, // 新增奖励领取防抖锁
      isRemaking: false, // 新增防抖状态锁
      // 响应式数据控制背景图路径
      isLimitMode: false,
      // 原始图片路径
      mainBg: 'https://download4.qcplay.com/tideng/new-version/home/big_bg.png', // 替换 @{mainImageUrl2} 为实际路径
      taskBg: 'https://download4.qcplay.com/tideng/new-version/home/task_bg.png',
      // 点击后切换的路径
      limitMainBg: 'https://download4.qcplay.com/tideng/new-version/home/limit_bg.png',
      limitTaskBg: 'https://download4.qcplay.com/tideng/new-version/home/limit_task.png',
      consume: 0, // 上限次数
      remakeShow: false, // 重开弹窗
      record_id: '', // 当前奖励的id
      helpedShow: false,
      currentRewardId: null, // 存储当前奖励ID
      rewardImageMap: {       // 奖励图片映射
        1: 'https://download4.qcplay.com/tideng/new-version/dialog/1.png',
        2: 'https://download4.qcplay.com/tideng/new-version/dialog/2.png',
        3: 'https://download4.qcplay.com/tideng/new-version/dialog/3.png',
        4: 'https://download4.qcplay.com/tideng/new-version/dialog/4.png',
        5: 'https://download4.qcplay.com/tideng/new-version/dialog/5.png',
        6: 'https://download4.qcplay.com/tideng/new-version/dialog/6.png',
      },
      rewardNameMap: {        // 奖励文本映射
        1: '钻石*9999',
        2: '神话魔法罐*10',
        3: '巨心自选宝箱（90级）*10',
        4: '黄金魔法罐*10',
        5: '火星石*100',
        6: '时空裂隙邀请函*20',
      },
      rewardName: '', // 恭喜获奖的奖励名称
      happyShow: false, // 恭喜获奖弹窗
      rewardMap: {
        1: '恶魔降临',
        2: '巨眸低语',
        3: '潮陨龙骸',
        4: '汐龙之息',
        5: '契约初现',
        6: '深渊回响'
      },
      card_record: [], //上一局卡牌的记录
      prevText: '',
      card_reward_record: 0,
      draw_type: 1, //1正常翻牌，2重开

      invite_code: '',
      cards: Array(3).fill().map(() => ({
        isFlipped: false,
        image: ''
      })),
      showModal: false,
      tjShow: false, // 翻翻乐图鉴
      reward_record: [], // 奖励信息
      ruleRewardShow: false,
      activeTab: 'rule',
      help_id: '', // 助力id
      helpShow: false, // title欧气爆棚弹窗
      helpSelfShow: false, // 不能助力自己的弹窗
      successHelpShow: false, // 助力成功弹窗
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/official/index_mobile.html',
      user_info: {}, // 用户信息
      logger: null,
      headerLogin: false,
      loginTypes: ["sms", "password", "channel"],
      logoutShow: false,
      task_list: Array.from({ length: 5 }, (_, index) => ({
        id: index + 1,  // id 从 1 开始
        status: 0       // 初始状态为 0
      })),
      help_number: 0, // 魔法币数量
      task_time: 0, // 可以翻牌的次数
      isRequesting: false, // 用于锁机制

      isFlipping: false, // 翻牌开始前锁定操作 
      isRemakingLock: false,
    }
  },
  computed: {
    isSpecialMode() {
      return this.consume == 24
    },

    mainBgResource() {
      return this.isSpecialMode ? this.limitMainBg : this.mainBg
    },
    taskBgResource() {
      return this.isSpecialMode ? this.limitTaskBg : this.taskBg
    },
    dynamicHeight() {
      return this.isSpecialMode ? '19.133333rem' : '31.4rem'
    },

    // 样式配置集中管理
    positionValues() {
      return {
        tipsTop: this.isSpecialMode ? '65.5%' : '39.5%',
        commonTop: this.isSpecialMode ? '36.6%' : '22.3%',
        turnTop: this.isSpecialMode ? '69.2%' : '42.2%',
        ruleTop: this.isSpecialMode ? '18%' : '11%',
        cardTop: this.isSpecialMode ? '42.5%' : '25.5%',
        remakeTop: this.isSpecialMode ? '68.5%' : '41.5%',
        historyTop: this.isSpecialMode ? '35.1%' : '21.1%',
      }
    },

    // 定位样式
    historyTop() {
      return { top: this.positionValues.historyTop }
    },
    remakeTop() {
      return { top: this.positionValues.remakeTop }
    },
    tipTop() {
      return { top: this.positionValues.tipsTop }
    },
    coinTop() {
      return { top: this.positionValues.commonTop }
    },
    tjHeight() {
      return { top: this.positionValues.commonTop }
    },
    turnTop() {
      return { top: this.positionValues.turnTop }
    },
    ruleHeight() {
      return { top: this.positionValues.ruleTop }
    },
    cardContainerHeight() {
      return { top: this.positionValues.cardTop }
    },

    // 复杂样式
    mainMobileStyle() {
      return { backgroundImage: `url(${this.mainBgResource})` }
    },
    taskHeight() {
      return {
        marginTop: this.isSpecialMode ? '4%' : '',
        height: this.dynamicHeight
      }
    },
    taskBgStyle() {
      return {
        backgroundImage: `url(${this.taskBgResource})`,
        height: this.dynamicHeight
      }
    },
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  mounted() {
    this.$nextTick(() => {
      const savedRewardId = localStorage.getItem('prev_reward_id');
      if (savedRewardId) {
        this.showHistory = true; // 刷新后直接显示历史记录
      }
      const { invite_code, token } = analysisParams(window.location.href);
      if (token) {
        noSecLogin({ token })
          .then((response) => {
            if (response.code == 200) {
              window.localStorage.setItem('access_token', response.data.access_token);
              // 然后需要重定向
              // 获取当前路由参数副本
              const newQuery = { ...this.$route.query };
              delete newQuery.token; // 删除token参数
              this.onInit(!!invite_code)
              // 无刷新路由替换
              this.$router.replace({
                path: '/new-version/enter',
                query: newQuery
              });
            } else {
              this.onToast(response.message)
              window.localStorage.setItem('access_token', "");
            }
          })
      } else {
        this.onInit(!!invite_code);
      }
      var linkUrl = `https://h5.qingcigame.com/tideng/new-version/enter${getRandomString()}`;
      this.isSetShare(linkUrl);

      this.monitoringEquipment();

      // 助力相关逻辑
      const params = analysisParams(window.location.href);
      if (params.invite_code && !window.localStorage.getItem("access_token")) {
        onHelpAPI({ invitation_code: params.invite_code })
          .then((response) => {
            if (response.reason == 'User') {
              // 弹出欧气爆棚
              this.helpShow = true
            }
          })
      }
    })
  },
  created() {
    const accessToken = window.localStorage.getItem("access_token");
    const delay1 = accessToken ? 300 : 0;
    // 统一设置防抖方法
    this.DebounceFlipCards = _.debounce(this._flipCards, delay1); // 翻牌

    // 初始化防抖函数（确保只创建一次）
    this.initializeDebouncedAPIRemake();

    this.DebounceRefresh = _.debounce(this._refresh, delay1); // 刷新
    this.DebounceAllGetReward = _.debounce(this._allGetReward, delay1); // 一键领取

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()
    const bl = buriedLogger('tideng', '提灯新版本上线h5');
    this.logger = bl
    const saved = localStorage.getItem('prev_reward_id');
    if (saved) {
      const prevId = JSON.parse(saved);
      this.prevText = this.rewardMap[prevId] || ''; // 显示对应的名称
      this.currentRewardId = prevId
    }
  },
  // 在watch中监听用户ID变化
  watch: {
    // 监听accessToken变化时重建防抖函数
    accessToken() {
      this.initializeDebouncedAPIRemake();
    }
  },
  methods: {
    // 是否是微信浏览器
    isWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.match(/Micromessenger/i) && ua.match(/Micromessenger/i)[0] === 'micromessenger'
    },
    getEgg() {
      if (this.isGettingEgg) return;
      this.isGettingEgg = true; // 加锁
      this.preventShow = true
      onGetRewardAPI({ reward_id: 7 })
        .then((response) => {
          if (response.code === 200) {
            this.onInit();
            this.onToast(response.message);
            this.eggShow = false
          } else if (response.message === '请勿频繁操作') {
            this.onToast(response.message);
          }
        })
        .finally(() => {
          // 请求完成后 1 秒释放锁
          setTimeout(() => {
            this.isGettingEgg = false;
            this.preventShow = false
          }, 1000);
        });
    },
    // 初始化防抖方法
    initializeDebouncedAPIRemake() {
      const delay = this.accessToken ? 1500 : 0;
      this.debouncedAPIRemake = _.debounce(this._executeAPIRemake, delay, {
        leading: true,
        trailing: true
      });
    },

    clickEgg() {
      if (!this.checkLogin()) {
        return;
      }
      if (this.is_get_egg) {
        this.onToast("很抱歉,奖励已经领取")
        return
      }
      this.eggShow = true
    },
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#b14e4c',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          Indicator.close();
          console.log(canvas, 'canvas')
          this.preventShow = false;
          this.shareShow = true
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          Indicator.close();
          this.preventShow = false
          console.log('err: 图片生成失败', err.message);
        });
    },
    closeCoin() {
      this.shareShow = false
    },
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/tideng/new-version/pc${getTimeStamp()}`
    },

    // 修改关闭弹窗方法
    closeHappyShow() {
      this.happyShow = false;

      // 提交暂存的卡牌记录
      if (this.pendingCards) {
        this.card_record = this.pendingCards;
        this.pendingCards = null;
        this.showHistory = true; // 控制显示历史区块
      }
    },

    closeRemakeShow() {
      this.remakeShow = false;

      // 提交暂存的卡牌记录
      if (this.pendingCards) {
        this.card_record = this.pendingCards;
        this.pendingCards = null;
        this.showHistory = true; // 控制显示历史区块
      }
    },

    jump(type) {
      const links = {
        live: 'https://l.taptap.cn/EPZ4fLEj?channel=rep-rep_ksqmxzt1ecc',
        sign: 'https://l.taptap.cn/GyOkMwYx?channel=rep-rep_jjo4rkxqwhf_h5url3722',
        turntable: 'https://h5.qingcigame.com/tideng/ani-appoint/enter'
      }
      window.location.href = links[type]
      const eventName = ['live', 'sign'].includes(type) ? '前往活动' : '进入游戏';
      this.logger.sum(`提灯新版本上线h5_点击${eventName}的次数`);
    },
    coinClick() {
      if (!this.checkLogin()) {
        return;
      }
      this.preventShow = true
      setTimeout(() => {
        let qrUrl = `https://h5.qingcigame.com/tideng/new-version/enter${getRandomString()}?invite_code=${this.invite_code}`
        this.qrcode('qrcode', qrUrl);
        this.qrcode('qrcode2', qrUrl);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      }, 500)
      this.logger.sum('提灯新版本上线h5_点击魔法币按钮的次数');
    },
    downloadGame() {
      this.logger.sum('提灯新版本上线h5_点击下载游戏按钮的次数');
      // 首页下载按钮
      const { kol } = analysisParams(window.location.href);
      const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
      if (this.isWechatBrowser()) {
        // 微信环境下
        this.guideShow = true
      } else if (kol) {
        if (isIOS) {
          window.location = "https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E-1-5%E7%89%88%E6%9C%AC%E5%85%89%E6%9A%97%E5%AF%B9%E5%86%B3/id1507356201?l=en";
        } else {
          // 安卓设备处理kol参数
          const formattedKol = kol.replace(/_/g, '-'); // 替换下划线为连字符
          const apkUrl = `https://download4.qcplay.com/apk-v2/${formattedKol}.apk`;
          window.location = apkUrl; // 跳转定制APK链接
        }
      } else {
        setTimeout(() => {
          if (isIOS) {
            window.location = "https://apps.apple.com/cn/app/%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E-1-5%E7%89%88%E6%9C%AC%E5%85%89%E6%9A%97%E5%AF%B9%E5%86%B3/id1507356201?l=en"
          } else {
            window.location = "https://download4.qcplay.com/apk-v2/qc-kol-1165733.apk";
          }
        }, 250);
      }
    },


    // 智能处理入口
    handleSmartRemake(no_check = false) {
      // 新增：前端点击频率拦截
      const now = Date.now();
      if (now - this.lastAPICallTime < this.clickCoolDown) {
        this.onToast("请勿频繁操作");
        return;
      }

      if (this.isRemakingLock) return;

      // 更新最后一次点击时间
      this.lastAPICallTime = now;

      // 原有逻辑保持不变
      this.isRemakingLock = true;
      this.preventShow = true;

      const isTopReward = no_check && this.currentRewardId == 1;
      const noHelpLeft = this.help_number === 0;

      if (isTopReward || noHelpLeft) {
        this._immediateFeedback(no_check);
        this.isRemakingLock = false;
        this.preventShow = false;
        return;
      }

      this.remakeShow = false;
      this.debouncedAPIRemake(no_check);
    },

    // 即时反馈逻辑
    _immediateFeedback(no_check) {
      if (no_check && this.currentRewardId == 1) {
        this.happyShow = false;
        this.remakeShow = true;
        return;
      }

      if (this.help_number === 0) {
        this.happyShow = false
        setTimeout(() => {
          let qrUrl = `https://h5.qingcigame.com/tideng/new-version/enter${getRandomString()}?invite_code=${this.invite_code}`
          this.qrcode('qrcode', qrUrl);
          this.qrcode('qrcode2', qrUrl);
          this.$nextTick(() => {
            this.generateShareImage();
          });
        }, 500)
        this.onToast("很抱歉,重开次数不足,请邀请好友助力");
        return
      }
    },

    // 防抖封装的核心API操作
    _executeAPIRemake(no_check) {
      this.happyShow = false;
      onTurnAPI({
        draw_type: 2,
        card_reward_record: this.card_reward_record
      }).then(async response => {
        if (response.code == 200) {
          this.onInit()
          this.showHistory = false;
          this.pendingCards = response.data.card_combination;
          this.record_id = response.data.record_id
          this.currentRewardId = response.data.reward_id; // 保存当前ID
          const prefix = this.currentRewardId < 4 ? 'a_' : '';
          this.prevText = this.rewardMap[this.currentRewardId] || ''; // 显示对应的名称
          // 依次翻转卡牌
          for (let i = 0; i < this.cards.length; i++) {
            this.cards[i].image = this.card_record[i]
            this.cards[i].image = prefix + this.card_record[i]; // 动态拼接前缀
            this.cards[i].isFlipped = true
            await new Promise(r => setTimeout(r, 500))
          }
          // 显示弹窗
          this.happyShow = true

          // 保存上一期的reward_id 判断奖励名称和对应的上一期奖励名
          localStorage.setItem('prev_reward_id', JSON.stringify(response.data.reward_id))

          // 重置卡牌
          setTimeout(() => {
            this.cards.forEach(c => c.isFlipped = false)
            this.isRemakingLock = false
            this.preventShow = false
          }, 1100)
        } else {
          this.isRemakingLock = false
          this.preventShow = false
        }
        if (response.message == '请勿频繁操作') {
          this.onToast('请勿频繁操作')
        }
      }).catch(error => {
        console.error('API Error:', error);
      })
    },


    getFinalReward() {
      if (this.isGettingReward) return;
      this.isGettingReward = true; // 加锁
      this.preventShow = true
      onGetRewardAPI({ reward_id: this.record_id })
        .then((response) => {
          if (response.code === 200) {
            this.onInit();
            this.onToast("领取成功，奖励已发放至角色邮箱");
            [this.happyShow, this.remakeShow] = [false, false];
          } else if (response.message == '请勿频繁操作') {
            this.onToast(response.message);
          } else {
            this.onToast(response.message)
          }
        })
      setTimeout(() => {
        this.isGettingReward = false;
        this.preventShow = false
      }, 1000);
    },
    _refresh() {
      this.logger.sum('提灯新版本上线h5_点击刷新状态按钮的次数');
      if (!this.checkLogin()) {
        return;
      }
      this.onInit()
      this.onToast('刷新成功')
    },
    _allGetReward() {
      this.logger.sum('提灯新版本上线h5_点击一键领取按钮的次数');

      if (!this.checkLogin()) return;

      // 计算实际翻牌次数（第二个任务状态为1时+2，其他任务+1）
      const flipCount = this.task_list.reduce((acc, task, index) => {
        if (task.status === 1) {
          return acc + (index === 1 ? 2 : 1); // 索引为1的任务（第二个任务）贡献2次，其他任务1次
        }
        return acc;
      }, 0);

      if (flipCount === 0) {
        this.onToast('暂无可领取的翻牌次数');
        return;
      }

      // 拼接所有有效任务的ID（状态为1的任务）
      const validTasks = this.task_list.filter(task => task.status === 1);
      const taskIds = validTasks.map(task => task.id).join(',');

      return getRewardAPI({ task_id: taskIds })
        .then((response) => {
          this.onToast(`翻牌次数+${flipCount}`); // 提示实际领取次数
          return this.onInit();
        })
        .catch((error) => {
          this.onToast(error.message);
        });
    },
    getReward(task_id) {
      return getRewardAPI({ task_id })
        .then((response) => {
          if (Number(response.code) !== 200) {
            throw new Error(response.message);
          }
          return this.onInit();
        })
        .catch((error) => {
          this.onToast(error.message);
          throw error; // 继续传递错误
        });
    },
    // 点击任务状态
    handleClick(id) {
      if (!this.checkLogin()) return;
      const now = Date.now();
      // 同时检查请求状态和时间间隔
      if (this.isRequesting || now - this.lastClickTime < 1500) return;

      this.lastClickTime = now;
      this.onTask(id);
    },
    onTask(task_id) {
      const status = this.task_list[task_id - 1].status;
      switch (status) {
        // 立即前往
        case 0:
          if (this.isRequesting) return;
          this.isRequesting = true;
          const taskConfig = {
            1: { log: '进入活动' },
            2: { log: '成功登录游戏《提灯与地下城》', toast: '您今天还没有登录过游戏呢，请登录后再来此页面领取哦~' },
            3: { log: '关注官方微信公众号', link: "weixin://dl/business/?t=Drc4aBO8Z2b", ajax: true },
            4: {
              log: '添加游戏企微账号',
              link: this.open_like
            },
            5: {
              log: '前往官网充值页面',
              link: "https://pay.qingcigame.com/pay?gameId=42",
              ajax: true
            },
          };

          if (taskConfig[task_id].ajax) {
            this.doTask(task_id, taskConfig)
              .catch(() => { })
              .finally(() => {
                this.isRequesting = false
              });
          }

          if (task_id == 4) {
            this.goLink(taskConfig[4].link);
          }

          if (task_id == 1 || task_id == 2 || task_id == 4) {
            this.isRequesting = false
          }

          if (taskConfig[task_id].toast) {
            this.onToast(taskConfig[task_id].toast)
          }
          break;


        case 1:
          if (this.isRequesting) return;
          this.isRequesting = true;

          this.getReward(task_id)
            .catch(() => { })
            .finally(() => {
              this.isRequesting = false
            });
          break;

        case 2:
          const taskLinks = {
            5: "https://pay.qingcigame.com/pay?gameId=42",
          };
          // 根据 task_id 获取链接
          const link = taskLinks[task_id];
          if (link) {
            this.goLink(link);
          }
      }
    },
    doTask(task_id, config) {
      return doTaskAPI({ task_id })
        .then(async response => {
          if (response.code !== 200) {
            throw new Error(response.message);
          }
          await this.onInit()
          if (config[task_id].link) {
            this.goLink(config[task_id].link);
          }
        })
        .catch((error) => {
          this.onToast(error.message);
        })
        .finally(() => {
          this.isRequesting = false;
        });
    },
    async _flipCards() {
      if (!this.checkLogin()) return;
      if (this.task_time == 0) {
        this.onToast("很抱歉，您没有可参与的次数")
        return
      }
      if (this.consume == 24) {
        this.onToast("很抱歉，已超过翻牌上限")
        return
      }
      if (this.isFlipping) return;
      this.isFlipping = true; // 开始前锁定操作
      this.preventShow = true // 组织用户点击其他区域的遮罩
      try {
        const response = await onTurnAPI({
          draw_type: this.draw_type,
          card_reward_record: this.card_reward_record
        });

        if (response.code === 200) {
          // 仅暂存卡牌数据
          this.pendingCards = response.data.card_combination;

          this.onInit();
          const { card_combination, record_id, reward_id } = response.data;

          Object.assign(this, {
            // card_record: card_combination,
            record_id,
            currentRewardId: reward_id,
            prevText: this.rewardMap[reward_id] || ''
          });

          // 卡牌动画逻辑
          const prefix = reward_id < 4 ? 'a_' : '';
          for (const [index, card] of this.cards.entries()) {
            card.image = `${prefix}${card_combination[index]}`;
            card.isFlipped = true;
            await new Promise(r => setTimeout(r, 500));
          }

          this.happyShow = true;
          localStorage.setItem('prev_reward_id', JSON.stringify(reward_id));

          setTimeout(() => {
            this.cards.forEach(c => c.isFlipped = false);
            this.isFlipping = false
            this.preventShow = false
          }, 1000);
        } else {
          this.isFlipping = false;
          this.preventShow = false;
        }
        if (response.reason == 'max_consume') {
          this.onToast(response.message)
          return
        }
        const TOAST_MESSAGES = new Set([
          '请勿频繁操作',
          '很抱歉,次数不足,请完成任务'
        ]);
        if (TOAST_MESSAGES.has(response.message)) {
          this.onToast(response.message);
        }
      } catch (error) {
        console.error('API请求异常:', error);
      }
    },
    popSwitch(name, state) {
      this[name] = state;
    },
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab
      }
    },
    qhBtn() {
      this.logoutShow = true
    },
    logoutBtn() {
      LogoutAPI().then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.clearAllData()
          this.osCancel()
          this.logoutShow = false
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        }
      });
    },
    clearAllData() {
      this.record_id = ''
      this.card_record = []
      this.consume = 0
      this.help_number = 0
      this.task_time = 0
      this.task_list = Array.from({ length: 5 }, (_, index) => ({
        id: index + 1,  // id 从 1 开始
        status: 0       // 初始状态为 0
      }))
      this.preventShow = false
      this.delayShow = false
      this.lastClickTime = 0
      this.remakeClickTime = 0
      this.isGettingReward = false // 新增奖励领取防抖锁
      this.isRemaking = false // 新增防抖状态锁
      this.remakeShow = false // 重开弹窗
      this.helpedShow = false
      this.currentRewardId = null // 存储当前奖励ID
      this.happyShow = false // 恭喜获奖弹窗
      this.cards = Array(3).fill().map(() => ({
        isFlipped: false,
        image: ''
      }))
      this.showModal = false
      this.shareShow = false // 魔法币点击后的助力弹窗
      this.tjShow = false // 翻翻乐图鉴
      this.ruleRewardShow = false
      this.helpShow = false // title欧气爆棚弹窗
      this.helpSelfShow = false // 不能助力自己的弹窗
      this.successHelpShow = false // 助力成功弹窗
      this.logoutShow = false
      this.isRequesting = false // 用于锁机制
      this.isFlipping = false // 翻牌开始前锁定操作 
      this.isRemakingLock = false
    },
    goLink(url) {
      window.location.href = url;
    },
    // 复制链接
    copyLink(copyName) {
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
    },
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '四载同辉共庆盛典',
        imgUrl:
          'https://download4.qcplay.com/qcgame-api/m8A34pYzEDVCvMCFqyOqfiIIOgpuPGgG8pgVMugS.png',
        desc: '「深渊的凝视」版本现已震撼开启，更有至高9999钻石等你来赢！点击查看详情~',
      })
    },
    // 登录校验
    checkLogin() {
      if (!this.user_info.user_id) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return false
      }
      return true
    },
    onBind() {
      this.clearAllData()
      const { invite_code } = analysisParams(window.location.href);
      this.onInit(!!invite_code);
    },
    logon() {
      this.logger.sum('提灯新版本上线h5_点击登录按钮的次数');
      this.changeLoginPopup(true);
    },
    switchBtn() {
      this.changeOsPopup(true)
    },
    onInit(no_help = false) {
      let notHelp = no_help
      onInitAPI().then((response) => {
        if (Number(response.code) === 200) {
          const { user_info } = response.data;
          this.headerLogin = true;
          this.help_id = user_info.user_id;
          this.onInitDataCallback(response);
          this.setUserInfo(user_info);
          this.user_info = user_info;
          this.consume = Math.abs(response.data.activity.consume);
          this.card_reward_record = response.data.activity.card_reward_record
          this.is_get_egg = response.data.activity.is_get_egg
          this.reward_id = response.data.activity.reward_id
          this.currentRewardId = this.reward_id
          this.prevText = this.rewardMap[this.currentRewardId] || ''; // 显示对应的名称
          this.record_id = response.data.activity.record_id
          if (!this.pendingCards) {
            // 只有当没有待处理记录时才更新
            this.card_record = response.data.activity.card_record;
            this.showHistory = true;
          }
          this.invite_code = response.data.activity.invite_code // 邀请码
          this.shareText = `距离9999钻石就差一张牌了！快快点击帮我换牌！https://h5.qingcigame.com/tideng/new-version/enter?invite_code=${this.invite_code}`
          this.task_list = response.data.activity.task_list; // 任务列表
          this.help_number = response.data.activity.help_number // 魔法币数量
          this.task_time = response.data.activity.task_time // 可以翻牌的次数
          this.reward_record = response.data.activity.reward_record // 抽到的奖励列表
          this.open_like = response.data.activity.open_like
          // 其他请求不要去请求这个onHelp
          if (notHelp) {
            const params = analysisParams(window.location.href);
            onHelpAPI({ invitation_code: params.invite_code })
              .then((response) => {
                if (response.reason == 'help_myself') {
                  // 不能助力自己
                  this.helpSelfShow = true
                }
                if (response.message == '助力成功') {
                  this.successHelpShow = true // 助力成功
                }
                if (response.reason == 'help_once_day') {
                  this.helpedShow = true
                }
                if (response.reason == 'not_info') {
                  this.onToast(response.message)
                }
              })
              .catch((error) => {
                console.log('errror', error)
              });
          }
        } else if (Number(response.code) === 401) {
          // 401 access_token失效过时了需要清空token
          window.localStorage.setItem("access_token", "");
        } else {
          Number(response.code) !== 401 && this.onToast(response.message);
        }
      });
    },
    goOfficeWeb() {
      // 跳转官网 
      setTimeout(() => {
        window.location = this.downloadUrl;
      }, 250);
    },
    // 注销
    osCancel() {
      this.user_info = {}
      this.headerLogin = false
      this.clearAllData()
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setUserInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
}
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/new-version/index/index.vue